import React from 'react';
import './Estadisticas.css';
 

const Estadisticas: React.FC = () => {


  return (
    <div className='chart-container'>
      <h3>Estadísticas</h3>

      
    </div>
  );
};

export default Estadisticas;
